import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import axios from "axios";
import { useState } from "react";
import { config } from "../../data/config";
import { getCookies } from "cookies-next";
import Swal from "sweetalert2";

export default function QACreator({ parent }: any) {
    const { t } = useTranslation();
    let cookie = getCookies();

    const [data, setData] = React.useState<any>({
        parent: parent
    });
    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState<any>(0);
    const [list, setList] = useState<any>(null);
    const [create, SetCreate] = useState<any>(parent);
    const [isOpen, setIsOpen] = useState(false);
    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);

    const inputstyle = "py-3 px-5 block w-full bg-blue-100  rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";
    const save = async (iparent: any) => {
        try {
            var path = `${config.url}/v1/dashboard/qa`;
            data.parent = create;
            let res = await axios({
                method: 'post',
                data: data,
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setData({
                parent: iparent
            })
            await load();
            var i = key + 1;
            setKey(i);
        } catch (error) {
            Swal.fire('Error Data')

        }
    }
    const load = async () => {
        try {
            var path = `${config.url}/v1/dashboard/qa/${parent}`;

            let res = await axios({
                method: 'get',
                data: data,
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setData({
                parent: parent
            })
            setList(res.data);
            var i = key + 1;
            setKey(i);
            closeModal();
        } catch (error) {
            Swal.fire('Error Data')

        }
    }
    const deleted = async (id: any) => {
        try {
            var path = `${config.url}/v1/dashboard/qa/${id}`;
            data.parent = create;
            let res = await axios({
                method: 'delete',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            await load();
            var i = key + 1;
            setKey(i);
        } catch (error) {
            Swal.fire({
                icon: 'warning',
                title: t('Has subcategories')
            })

        }
    }
    const newquiz = (iparent: any) => {
        SetCreate(iparent);

        openModal();
    }
    useEffect(() => {
        load();
    }, []);
    return (
        <div>

            <div>
                {isOpen && (
                    <>
                        {/* Background overlay */}
                        <div
                            className="fixed inset-0 bg-black opacity-50 z-40  "
                            onClick={closeModal}
                        ></div>

                        {/* Dialog content */}
                        <div className="fixed inset-0 flex items-center justify-center z-50">
                            <div className="bg-white rounded-lg shadow-lg p-6 w-[80%] max-w-full">

                                <div key={key}>
                                    <div className="w-full">
                                        <div className="text-right">
                                            <label  >{t('تیتر')}  </label>
                                            <input
                                                defaultValue={data.title}
                                                dir='rtl'
                                                className={`${inputstyle}     ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                                placeholder="تیتر"
                                                onChange={(e) => setData({ ...data, title: e.target.value })}
                                            />
                                        </div>
                                        <div className="text-right mt-4">
                                            <label  >{t('توضیحات')}  </label>
                                            <textarea
                                                defaultValue={data.description}
                                                dir='rtl'
                                                className={`${inputstyle}     ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                                placeholder="توضیحات"
                                                onChange={(e) => setData({ ...data, description: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                    {/* onClick={(e) => { save(create) }} */}

                                <div className="flex gap-4">
                                    
                                <button
                                        onClick={() => { save(create) }}
                                        type="button" className="py-2 mt-5 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-800 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-700 dark:focus:bg-neutral-700" data-hs-overlay="#hs-stacked-overlays-2"
                                        data-hs-overlay-options='{
          "isClosePrev": false
        }'>
                                        ذخیره سازی
                                    </button>
                                    <button
                                        onClick={() => { closeModal() }}
                                        type="button" className="py-2 mt-5 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-800 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-700 dark:focus:bg-neutral-700" data-hs-overlay="#hs-stacked-overlays-2"
                                        data-hs-overlay-options='{
          "isClosePrev": false
        }'>
                                        بستن
                                    </button>
                                </div>

                                </div>
                            </div>
                        </div>
                    </>
                )}


                <div
                    id="hs-scale-animation-modal"
                    className="hs-overlay hidden overflow-x-hidden size-full fixed top-0 start-0 z-[3888]  overflow-y-auto pointer-events-none"
                    role="dialog"
                    tabIndex={-1}
                    aria-labelledby="hs-scale-animation-modal-label"
                >
                    <div className=" hs-overlay-animation-target hs-overlay-open:scale-100 hs-overlay-open:opacity-100 scale-95 opacity-0 ease-in-out transition-all duration-200 sm:max-w-lg sm:w-full m-3 sm:mx-auto min-h-[calc(100%-3.5rem)] flex items-center">
                        <div className="w-full p-6 flex flex-col bg-white border shadow-sm rounded-xl pointer-events-auto dark:bg-neutral-800 dark:border-neutral-700 dark:shadow-neutral-700/70">

                        </div>
                    </div>
                </div>
                <div className="m-4 ">
                <button type="button" className="
                py-3 px-4 inline-flex  items-center gap-x-2 
                text-sm font-medium rounded-lg border 
                border-transparent bg-blue-600 text-white
                 hover:bg-blue-700 focus:outline-none focus:bg-blue-700
                  disabled:opacity-50 disabled:pointer-events-none
                  " onClick={(e) => { newquiz(parent) }}>
                    سوال جدید
                </button>
                </div>


                <div className="hs-accordion-group">
                    {
                        list != null && list.message.map((item: any) => {
                            return (
                                <div dir="rtl" className="text-right">

                                    <div className="flex flex-col bg-white border shadow-sm rounded-xl dark:bg-neutral-900 dark:border-neutral-700 dark:shadow-neutral-700/70">
                                        <div className="text-left">
                                            <button type="button" onClick={(e) => { deleted(item.id) }} className="bg-red-600 p-2 rounded-[20]">
                                                <img src="/icons/trash.svg" width={20}></img>
                                            </button>
                                        </div>

                                        <div className="p-4 md:p-5">
                                            <h3 className="text-lg font-bold text-gray-800 dark:text-white">
                                                {item.title}
                                            </h3>
                                            <p className="mt-2 text-gray-500 dark:text-neutral-400">
                                                {item.description}
                                            </p>
                                            <button type="button" className=" mt-5
                py-3 px-4 inline-flex items-center gap-x-2 
                text-sm font-medium rounded-lg border 
                border-transparent bg-blue-600 text-white
                 hover:bg-blue-700 focus:outline-none focus:bg-blue-700
                  disabled:opacity-50 disabled:pointer-events-none
                  " onClick={(e) => { newquiz(item.id) }}>
                                                پاسخ جدید
                                            </button>
                                        </div>
                                        {item.toAnswer.map((i: any) => {
                                            return (
                                                <div className="p-4 md:p-5 bg-red-100 border-[1px] m-4 rounded-[20] ">
                                                    <div className="text-left">
                                                        <button type="button" onClick={(e) => { deleted(i.id) }} className="bg-red-600 p-2 rounded-[20]">
                                                            <img src="/icons/trash.svg" width={20}></img>
                                                        </button>
                                                    </div>
                                                    <h3 className="text-lg font-bold text-gray-800 dark:text-white">
                                                        {i.title}
                                                    </h3>
                                                    <p className="mt-2 text-gray-500 dark:text-neutral-400">
                                                        {i.description}
                                                    </p>

                                                </div>
                                            )
                                        })}

                                    </div>

                                </div>
                            )
                        })
                    }

                </div>
            </div>
        </div>
    )
}